var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 2.66667H4V4.95238H3.2V2.66667ZM4 7.20762C3.868 7.22667 3.736 7.2381 3.6 7.2381C2.052 7.2381 0.8 6.04571 0.8 4.57143C0.8 3.09714 2.052 1.90476 3.6 1.90476C4.728 1.90476 5.696 2.54095 6.14 3.45143C6.224 3.44381 6.312 3.42857 6.4 3.42857C6.62 3.42857 6.828 3.47048 7.028 3.53524C6.892 3.13143 6.684 2.7581 6.412 2.43429L6.98 1.89333C6.8 1.69905 6.62 1.52381 6.416 1.35619L5.848 1.90476C5.228 1.42476 4.448 1.14286 3.6 1.14286C1.612 1.14286 0 2.6781 0 4.57143C0 6.46476 1.612 8 3.6 8C3.768 8 3.932 7.98476 4.096 7.96571C4.036 7.82095 4 7.66476 4 7.50476V7.20762ZM4.8 0H2.4V0.761905H4.8V0ZM8 6.20952V7.54286C8 7.77143 7.76 8 7.48 8H5.28C5.04 8 4.8 7.77143 4.8 7.50476V6.17143C4.8 5.94286 5.04 5.71429 5.28 5.71429V5.14286C5.28 4.60952 5.84 4.19048 6.4 4.19048C6.96 4.19048 7.52 4.60952 7.52 5.14286V5.71429C7.76 5.71429 8 5.94286 8 6.20952ZM7 5.14286C7 4.8381 6.72 4.64762 6.4 4.64762C6.08 4.64762 5.8 4.8381 5.8 5.14286V5.71429H7V5.14286Z",
    fill: "#5D3115"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedClock);
export default __webpack_public_path__ + "static/media/locked_clock.4dc5b2ae97f77c7efd0382e1ea61651d.svg";
export { ForwardRef as ReactComponent };